import {CurrentEntryMergeConflicts} from './stacks-merge-conflicts-and-rebase-section/merge-conflicts/CurrentEntryMergeConflicts'
import {DownstackMergeConflicts} from './stacks-merge-conflicts-and-rebase-section/merge-conflicts/DownstackMergeConflicts'
import {OptionalRebase} from './stacks-merge-conflicts-and-rebase-section/rebase/OptionalRebase'
import {RequiredRebase} from './stacks-merge-conflicts-and-rebase-section/rebase/RequiredRebase'
import type {StacksMergeConflictsAndRebaseSectionProps} from './stacks-merge-conflicts-and-rebase-section/types'

export type {StacksMergeConflictsAndRebaseSectionProps}

/**
 * Renders the merge-box section describing stack-wide merge conflicts and rebase state.
 *
 * Each scenario is its own component and decides whether to render based on `status`,
 * mirroring the `EffectiveEntryStatusLabel` pattern. Exactly one scenario renders for a
 * given status; an `undefined` status renders nothing.
 */
export function StacksMergeConflictsAndRebaseSection(props: StacksMergeConflictsAndRebaseSectionProps) {
  return (
    <>
      <CurrentEntryMergeConflicts {...props} />
      <DownstackMergeConflicts {...props} />
      <RequiredRebase {...props} />
      <OptionalRebase {...props} />
    </>
  )
}
